export function reloadAppAndRedirectToMonitor() {
  window.location.assign('/monitor');
}
